import React from 'react'
import PropTypes from 'prop-types'
import Link from '@components/link'
import Box from '@material-ui/core/Box'
import { CtaText, Image } from '@components/atoms'
import Typography from '@material-ui/core/Typography'
import useHover from '@hooks/useHover'
import useIsMobile from '@hooks/useIsMobile'
import ButtonCta from '@components/atoms/button-cta'
import Card from '@material-ui/core/Card'
import useStyles from './premier-golf-leaderboard-banner.styles'

const PremierGolfLeaderboardBanner = (props) => {
  const {
    secondNativeAdCtaUrl,
  } = props
  const styles = useStyles()
  const isMobile = useIsMobile()
  const [, isHovered] = useHover()

  const title = 'Experiences include world-class destinations, Major Championships, the Ryder Cup and more'
  const backgroundImageUrl = 'https://images.ctfassets.net/56u5qdsjym8c/1iSi0JoZZFipwdgkMfCBCm/61603a00293880178527c3e02761da3d/JakeNicholas_Par3_12.jpg'
  const logoUrl = 'https://images.ctfassets.net/56u5qdsjym8c/30oBjTq1vspaFL19eLgRDy/a47a732813f886cb033be16e8e8b8277/premier-logo.svg'
  const tagline = 'Book Your Next Golf Trip With Premier Golf'

  return isMobile ? (
    <Link externalLink={secondNativeAdCtaUrl} title={title}>
      <Card className={styles.rootMobile}>
        <div className={styles.imageContainer}>
          {backgroundImageUrl && <Image className={styles.image} src={`${backgroundImageUrl}?h=200&w=800&fit=fill&fl=progressive&q=80`} alt="View page for Premier Golf" />}
          <Typography variant="h6" className={styles.headlineOverlay}>
            {tagline}
          </Typography>
        </div>
        <Box className={styles.cardInfo} aria-hidden="true">
          <Box className={styles.logoWrapper}>
            {logoUrl && <Image className={styles.logo} src={logoUrl} alt="Premier Golf logo" />}
          </Box>
          <Box className={styles.headlineWrapper}>
            <Typography variant="h6" className={styles.headline}>{title}</Typography>
          </Box>
          <ButtonCta
            variant="text"
            arrow
            className={styles.ctaButton}
            externalLink={secondNativeAdCtaUrl}
            title={title}
          >
            Find out more
          </ButtonCta>
        </Box>
      </Card>
    </Link>
  ) : (
    <Link externalLink={secondNativeAdCtaUrl} className={styles.root} title={title}>
      <Box className={styles.cardWrapper}>
        <div className={styles.imageContainer}>
          {backgroundImageUrl && <Image className={styles.image} src={`${backgroundImageUrl}?h=200&w=800&fit=fill&fl=progressive&q=80`} alt="View page for Premier Golf" />}
          <Typography variant="h6" className={styles.headlineOverlay}>
            {tagline}
          </Typography>
        </div>
        <Box className={styles.cardInfo} aria-hidden="true">
          <Box className={styles.logoWrapper}>
            {logoUrl && <Image className={styles.logo} src={logoUrl} alt="Premier Golf logo" />}
          </Box>
          <Box className={styles.headlineWrapper}>
            <Typography variant="h6" className={styles.headline}>{title}</Typography>
          </Box>
          <Box className={styles.detailsWrapper}>
            <CtaText hovered={isHovered} variant="subtitle2" className={styles.cta}>
              Find out more
            </CtaText>
          </Box>
        </Box>
      </Box>
    </Link>
  )
}

PremierGolfLeaderboardBanner.propTypes = {
  secondNativeAdCtaUrl: PropTypes.string,
}

export default PremierGolfLeaderboardBanner
